import { render } from "./GroupExcursionReport.vue?vue&type=template&id=4afcbbd3"
import script from "./GroupExcursionReport.vue?vue&type=script&lang=js"
export * from "./GroupExcursionReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__